<div class="main">
  <h2>
    <span>
      {{ 'globalUi.notifications.title' | translate }}
      @if (notifications.length > 0) {
        <span>({{notifications.length}})</span>
      }
    </span>
    <span class="close-notifications">
      ×
    </span>
  </h2>
  <div class="notifications-list">
    @if (notifications.length > 0) {
      @for (notif of notifications; track notif) {
        <a [routerLink]="notif.link" class="notifications-card" >
        <div class="notifications-details" [ngClass]="{
          'notification-red': notif.type == 'Missed' || notif.type == 'ORDER_CANCELLED', 
          'notification-green': notif.type == 'Replied' || notif.type == 'NEW_ORDER' || notif.type == 'NEW_CLIENT'
        }">
            <div class="icon">
              @if (notif.type == 'Replied' || notif.type == 'Missed' || notif.type == 'NEW_CLIENT') {
                <img alt=""
                  src="../../../assets/icons/notification-icon1.svg">
                }
                @if (notif.type == 'NEW_ORDER' || notif.type == 'ORDER_CANCELLED') {
                  <img alt=""
                    src="../../../assets/icons/notification-icon2.svg">
                  }
                  @if (notif.type == 'WELCOME' || notif.type == 'PRODUCT_OUT_OF_STOCK') {
                    <img alt=""
                      src="../../../assets/icons/notification-icon3.svg">
                    }
                  </div>
                  <div>
                    <h3>
                      {{notif.title}}
                    </h3>
                    <p>
                      {{notif.value}}
                    </p>
                  </div>
                </div>
                <div class="date-container">
                  <span>{{notif.date | date: 'dd-MM-yyyy H:mm'}}</span>
                </div>
              </a>
            }
          }
          @if (notifications.length === 0) {
            <div class="not-found">
              {{ 'globalUi.notifications.empty' | translate }}
            </div>
          }
        </div>
      </div>